import { SavedFile, SavedFiles } from './hooks/useDocuments'

interface GetInvalidDocuments {
  identity: File | undefined
  identityIssueDate: string
  proofOfResidence: File | undefined
  proofOfResidenceIssueDate: string
  anvisaAuthorization: File | undefined
  anvisaAuthorizationIssueDate: string
  bondProof: File | undefined
  bondProofIssueDate: string
  isProofOfResidenceInOtherName: boolean
  savedFiles: SavedFiles
}

export const getInvalidDocuments = ({
  identity,
  identityIssueDate,
  proofOfResidence,
  proofOfResidenceIssueDate,
  anvisaAuthorization,
  anvisaAuthorizationIssueDate,
  bondProof,
  bondProofIssueDate,
  isProofOfResidenceInOtherName,
  savedFiles
}: GetInvalidDocuments) => {
  const errors: string[] = []

  if (identity && identityIssueDate.length !== 'dd/mm/yyyy'.length) {
    errors.push('identityIssueDate')
  }
  if (anvisaAuthorization && anvisaAuthorizationIssueDate.length !== 'mm/yyyy'.length) {
    errors.push('anvisaAuthorizationIssueDate')
  }

  if (proofOfResidence && proofOfResidenceIssueDate.length !== 'dd/mm/yyyy'.length) {
    errors.push('proofOfResidenceIssueDate')
  }

  if (bondProof && bondProofIssueDate.length !== 'mm/yyyy'.length) {
    errors.push('bondProofIssueDate')
  }

  if (isProofOfResidenceInOtherName && proofOfResidence && !savedFiles.bondProof && !bondProof) {
    errors.push('bondProof')
  }

  return errors
}

export const getErrorMessage = (fieldName: string, errors: string[]) => {
  const fieldHasError = errors.includes(fieldName)
  if (!fieldHasError) return undefined

  switch (fieldName) {
    case 'identityIssueDate':
      return 'Data de emissão do documento de identidade inválida'
    case 'proofOfResidence':
      return 'Comprovante de residência é obrigatório quando o campo abaixo estiver checado'
    case 'proofOfResidenceIssueDate':
      return 'Data de emissão do comprovante de residência inválida'
    case 'anvisaAuthorizationIssueDate':
      return 'Data de emissão da autorização da Anvisa inválida'
    case 'bondProof':
      return 'Comprovante de vínculo obrigatório'
    case 'bondProofIssueDate':
      return 'Data de emissão do comprovante de vínculo inválida'
    default:
      return undefined
  }
}

const fromTimestampToDate = (type: string, timestamp?: string) => {
  if (!timestamp) return ''

  const date = new Date(timestamp)
  const day = (date.getDate() + 1).toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  switch (type) {
    case 'IDENTIDADE':
    case 'RESIDENCIAL':
      return `${day}/${month}/${year}`
    case 'ANVISA':
    case 'VINCULO':
      return `${month}/${year}`
    default:
      return ''
  }
}

export const fromFilesArrayToSavedFiles = (savedFiles: SavedFile[]): SavedFiles => {
  let formattedSavedFiles: SavedFiles = {}

  savedFiles.forEach((savedFile) => {
    switch (savedFile.type) {
      case 'IDENTIDADE':
        formattedSavedFiles = {
          ...formattedSavedFiles,
          identity: {
            ...savedFile,
            emission: fromTimestampToDate(savedFile.type, savedFile.emission)
          }
        }
        return
      case 'RESIDENCIAL':
        formattedSavedFiles = {
          ...formattedSavedFiles,
          proofOfResidence: {
            ...savedFile,
            emission: fromTimestampToDate(savedFile.type, savedFile.emission)
          }
        }
        return
      case 'ANVISA':
        formattedSavedFiles = {
          ...formattedSavedFiles,
          anvisaAuthorization: {
            ...savedFile,
            emission: fromTimestampToDate(savedFile.type, savedFile.emission)
          }
        }
        return
      case 'VINCULO':
        formattedSavedFiles = {
          ...formattedSavedFiles,
          bondProof: {
            ...savedFile,
            emission: fromTimestampToDate(savedFile.type, savedFile.emission)
          }
        }
        break
      default:
        break
    }
  })

  return formattedSavedFiles
}
